import { Box, Button, Container } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { faqWritePermission } from '../../store/selectors/account.selector';
import decOfNum from '../../utils/decOfNum';

const FaqToolbar = ({
  faqsActive,
  faqsDeleteClick,
  ...props
}) => {
  const editPermission = useSelector(faqWritePermission);

  return (
    <Box sx={{ my: 4 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: 3,
        }}
      >
        {/*<Button>
          Импорт
        </Button>
        <Button sx={{ ml: 1 }}>
          Экспорт
        </Button>*/}
        {editPermission && (
          <RouterLink to="/app/faq/add/faq">
            <Button
              sx={{ ml: 1 }}
              variant="contained"
            >
              Добавить вопрос
            </Button>
          </RouterLink>
        )}
        {editPermission && !!faqsActive && (
          <Button
            sx={{ ml: 1 }}
            color="secondary"
            variant="contained"
            onClick={() => faqsDeleteClick()}
          >
            Удалить&nbsp;
            { faqsActive }
            &nbsp;
            { decOfNum(faqsActive, ['вопрос', 'вопроса', 'вопросов']) }
          </Button>
        )}
      </Box>
    </Box>
  );
};

FaqToolbar.propTypes = {
  faqsActive: PropTypes.number,
  faqsDeleteClick: PropTypes.func,
};

FaqToolbar.defaultProps = {
  faqsActive: 0,
  faqsDeleteClick: null,
};

export default FaqToolbar;
